<template>
    <div class="p-4">
        <div class="vx-row">
            <div v-for="(i, index) in marketplaceList" :key="index" class="vx-col w-full lg:w-1/2 xl:w-1/2">
              <div :class="{'mb-base': (index == 0 || index == 1)}">
                <marketplace-item :marketplaceData="i" />
              </div>
            </div>
          </div>
    </div>
</template>

<script>
import MarketplaceItem from '../components/MarketplaceItem.vue';
import marketplaceList from '@/assets/data/user-marketplace-list.js'
export default {
    components: {
        MarketplaceItem
    },
    data() {
        return {
            marketplaceList
        }
    }
}
</script>

<style scoped>

</style>